<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BillingRateCML",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  